import { memo } from "react";

import Typography from "ds/components/Typography";
import Icon from "ds/components/Icon";
import { ManagedUserGroup } from "types/generated";
import { getProviderLogo } from "views/Account/Settings/Users/helpers";

type IdpGroupLoginMethodCellProps = {
  group: ManagedUserGroup;
};

const IdpGroupLoginMethodCell = ({ group }: IdpGroupLoginMethodCellProps) => {
  const ProviderIcon = getProviderLogo(group.identityProvider);

  if (!ProviderIcon) return null;

  return (
    <Typography tag="span" variant="p-body3">
      {typeof ProviderIcon === "string" ? ProviderIcon : <Icon size="large" src={ProviderIcon} />}
    </Typography>
  );
};

export default memo(IdpGroupLoginMethodCell);
